document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-email-signup-subscriber]').forEach(function (section) {
    var unlockKey = (section.dataset.postSubmitUnlockKey || '').trim();
    if (!unlockKey) return;
    try {
      localStorage.setItem(unlockKey, '1');
    } catch (err) {
      /* ignore */
    }
  });

  var Mc = window.McSignupForm;
  if (!Mc) {
    console.warn('mailchimp-form-helpers.js missing; email signup validation disabled');
  }

  document.querySelectorAll('[data-email-signup]:not([data-email-signup-initialized])').forEach(function (section) {
    section.setAttribute('data-email-signup-initialized', 'true');

    var modalId = section.dataset.emailModalId;
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    var openBtn = section.querySelector('[data-email-signup-open]');
    var form = modal && modal.querySelector('[data-email-signup-form]');
    var previewInput = section.querySelector('[data-email-signup-preview]');

    if (!modal || !openBtn || !form) return;

    var emailField = form.querySelector('input[name="EMAIL"]');

    if (Mc) {
      Mc.bindClearOnInput(form);
    }

    function openModal() {
      if (Mc) Mc.clearErrors(form);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (previewInput && emailField && previewInput.value.trim()) {
        emailField.value = previewInput.value.trim();
      }
      setTimeout(function () {
        if (emailField) emailField.focus();
      }, 50);
    }

    function closeModal() {
      if (form.classList.contains('is-submitting')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', function () {
      openModal();
    });

    modal.querySelectorAll('[data-email-signup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formOk = true;
      if (Mc) {
        formOk = Mc.validate(form);
      } else if (!form.checkValidity()) {
        form.reportValidity();
        formOk = false;
      }
      if (!formOk) {
        var firstInvalid = form.querySelector(':invalid');
        if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
        return;
      }

      var submitBtn = form.querySelector('button[type="submit"]');
      if (Mc) {
        Mc.setLoading(form, true, submitBtn);
      } else {
        submitBtn.dataset.mcFallbackOriginal = submitBtn.textContent.trim();
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.classList.add('is-loading');
        form.classList.add('is-submitting');
        submitBtn.textContent = submitBtn.dataset.loadingText || 'Submitting…';
      }

      var finalized = false;
      var iframe = null;

      function finalize() {
        if (finalized) return;
        finalized = true;
        clearTimeout(doneTimer);
        if (Mc) {
          Mc.setLoading(form, false, submitBtn);
        } else {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.classList.remove('is-loading');
          form.classList.remove('is-submitting');
          if (submitBtn.dataset.mcFallbackOriginal !== undefined) {
            submitBtn.textContent = submitBtn.dataset.mcFallbackOriginal;
            delete submitBtn.dataset.mcFallbackOriginal;
          }
        }
        closeModal();
        form.removeAttribute('target');

        var unlockKey = (section.dataset.postSubmitUnlockKey || '').trim();
        var redirectUrl = (section.dataset.postSubmitRedirect || '').trim();
        if (unlockKey) {
          try {
            localStorage.setItem(unlockKey, '1');
          } catch (err) {
            /* ignore */
          }
        }
        if (redirectUrl) {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
          window.location.assign(redirectUrl);
          return;
        }

        form.reset();
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }

      iframe = document.createElement('iframe');
      iframe.setAttribute('title', 'Newsletter signup');
      iframe.name = 'email-mailchimp-' + String(Date.now());
      iframe.setAttribute(
        'style',
        'position:absolute;width:0;height:0;border:0;left:-9999px;top:0;visibility:hidden'
      );
      document.body.appendChild(iframe);
      form.setAttribute('target', iframe.name);

      var doneTimer = setTimeout(finalize, 2000);

      if (typeof HTMLFormElement !== 'undefined' && HTMLFormElement.prototype.submit) {
        HTMLFormElement.prototype.submit.call(form);
      } else {
        form.submit();
      }
    });
  });

  if (!window.__emailSignupEscapeBound) {
    window.__emailSignupEscapeBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.email-signup-modal.is-open').forEach(function (modalEl) {
        var innerForm = modalEl.querySelector('[data-email-signup-form]');
        if (innerForm && innerForm.classList.contains('is-submitting')) return;
        modalEl.classList.remove('is-open');
        modalEl.setAttribute('aria-hidden', 'true');
      });
      document.body.style.overflow = '';
    });
  }
});
